module.exports = __webpack_public_path__ + "img/sleeve opening.6c68dd0f.png";